const translations = {
  // Navbar
  "nav.about": "About",
  "nav.services": "Services",
  "nav.infrastructure": "Infrastructure",
  "nav.quote": "Get a Quote",

  // Hero
  "hero.badge": "Premium Digital Solutions",
  "hero.title1": "Where creativity",
  "hero.title2": "meets",
  "hero.title3": "performance",
  "hero.subtitle": "Creative digital solutions to transform your company\'s online presence",
  "hero.cta.quote": "Get a Quote",
  "hero.cta.services": "View Services",

  // About
  "about.label": "About Us",
  "about.title1": "We transform ideas into",
  "about.title2": "digital experiences",
  "about.p1": "MidiaHost is a company specialised in digital solutions, combining creative design to transform ideas into high-impact digital experiences. Based in Portugal, we are passionate about creating websites that not only stand out visually, but are also effective in generating concrete results for our clients.",
  "about.p2": "With a client-centred approach, we develop personalised projects that reflect the unique identity of each brand. From responsive design to functional development, every detail is crafted to ensure a strong, intuitive and optimised online presence.",
  "about.p3": "In addition to website creation, MidiaHost has a strategic partnership with SkyHost, the company responsible for hosting infrastructure and cloud services. We work side by side with companies from different sectors, helping them grow in the digital world with solutions tailored to their needs.",
  "about.stat1.value": "100+",
  "about.stat1.label": "Projects Delivered",
  "about.stat2.value": "50+",
  "about.stat2.label": "Satisfied Clients",
  "about.stat3.value": "5+",
  "about.stat3.label": "Years of Experience",

  // Services
  "services.label": "Services",
  "services.title": "What we do for you",
  "services.subtitle": "Complete digital solutions to elevate your online presence",
  "services.learnMore": "Learn more",
  "services.s1.title": "One Page Websites",
  "services.s1.desc": "Modern single-page sites, perfect for direct and impactful presentations",
  "services.s2.title": "Informational Websites",
  "services.s2.desc": "Complete platforms to present your company in a professional manner",
  "services.s3.title": "E-commerce",
  "services.s3.desc": "Optimised online stores to sell your products efficiently",
  "services.s4.title": "Visual Identity",
  "services.s4.desc": "Creation of logos and visual elements that represent your brand",
  "services.s5.title": "Promotional Materials",
  "services.s5.desc": "Design of digital and physical materials to promote your business",
  "services.s6.title": "Print Design",
  "services.s6.desc": "Flyers, banners and other high-quality graphic materials",
  "services.s7.title": "Photography",
  "services.s7.desc": "Professional photo coverage for your events and projects",
  "services.s8.title": "Videography",
  "services.s8.desc": "Professional video production to tell your brand\'s story",
  "services.s9.title": "Live Streaming",
  "services.s9.desc": "High-quality live broadcasts for your events",

  // Infrastructure
  "infra.title": "Enterprise-level infrastructure",
  "infra.p1": "MidiaHost provides its own private cloud, designed exclusively to deliver projects securely, quickly and in a personalised way to its clients. In strategic partnership with SkyHost, we guarantee excellent hosting infrastructure and cloud services.",
  "infra.p2": "This unique combination allows us to offer complete digital solutions, from design to hosting, all in one place with the highest quality and reliability.",
  "infra.f1.title": "Private Cloud",
  "infra.f1.desc": "Exclusive infrastructure for your projects",
  "infra.f2.title": "Advanced Security",
  "infra.f2.desc": "Data protection and automatic backups",
  "infra.f3.title": "Optimised Performance",
  "infra.f3.desc": "Guaranteed speed and stability",
  "infra.f4.title": "24/7 Support",
  "infra.f4.desc": "Technical assistance always available",

  // Why Choose
  "why.label": "Advantages",
  "why.title": "Why choose MidiaHost",
  "why.b1.title": "Design that converts",
  "why.b1.desc": "We create visual experiences that not only impress, but also generate concrete results for your business",
  "why.b2.title": "Personalised Solutions",
  "why.b2.desc": "Each project is unique and developed to meet your specific needs",
  "why.b3.title": "Dedicated Support",
  "why.b4.title": "Optimised Performance",
  "why.b4.desc": "Fast, responsive websites optimised for all devices and search engines",
  "why.b5.title": "Professional end-to-end digital experience",
  "why.b5.desc": "From strategy to launch, we accompany every step of your digital project",

  // Contact
  "contact.title": "Let\'s talk",
  "contact.subtitle": "Ready to transform your digital presence? Get in touch with us and find out how we can help your business grow online.",
  "contact.email.label": "Email",
  "contact.phone.label": "Phone",
  "contact.location.label": "Location",
  "contact.location.value": "Portugal",
  "contact.social.label": "Follow us",
  "contact.form.name": "Full name",
  "contact.form.email": "Email",
  "contact.form.company": "Company (optional)",
  "contact.form.message": "Message",
  "contact.form.submit": "Send message",
  "contact.form.sending": "Sending...",
  "contact.form.success": "Message sent successfully! We will get in touch soon.",
  "contact.form.error": "Error sending message. Please try again.",

  // Footer
  "footer.slogan": "Where creativity meets performance",
  "footer.desc": "Creative digital solutions to transform your company\'s online presence",
  "footer.newsletter.title": "Newsletter",
  "footer.newsletter.desc": "Subscribe to receive the latest news",
  "footer.newsletter.placeholder": "Your email",
  "footer.newsletter.privacy": "We respect your",
  "footer.newsletter.privacyLink": "privacy",
  "footer.services.title": "Services",
  "footer.services.websites": "Website Creation",
  "footer.services.design": "Graphic Design",
  "footer.services.ecommerce": "E-commerce",
  "footer.services.events": "Event Coverage",
  "footer.services.cloud": "Cloud Infrastructure",
  "footer.social.title": "Follow us",
  "footer.copyright": "All rights reserved.",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",

  // CTA Section
  "cta.title": "Ready to transform your digital presence?",
  "cta.subtitle": "Join the companies that already trust MidiaHost to grow in the digital world.",
  "cta.button": "Get a Quote",

  // Service Pages
  websitesOnePage: {
    title: 'One Page Websites',
    subtitle: 'Modern single-page websites for fast presentation and direct communication',
    description: 'We create professional one-page websites, ideal for companies that need an impactful and direct online presence. Perfect for landing pages, portfolios, and product or service presentations.',
    includes: {
      title: 'What\'s included',
      items: [
        { title: 'Responsive Design', desc: 'Layout adaptable to all devices and screen sizes' },
        { title: 'Smooth Navigation', desc: 'Animated scrolling between sections for better experience' },
        { title: 'SEO Optimization', desc: 'Structure optimized for search engines' },
        { title: 'Contact Form', desc: 'Integrated system to receive messages' },
        { title: 'Social Media Integration', desc: 'Links and widgets for your social networks' },
        { title: 'Optimized Performance', desc: 'Fast and efficient loading' }
      ]
    },
    process: {
      title: 'How we work',
      steps: [
        { title: 'Briefing', desc: 'Initial meeting to understand your goals and needs' },
        { title: 'Planning', desc: 'Definition of structure, content and features' },
        { title: 'Design', desc: 'Visual layout creation aligned with your brand' },
        { title: 'Development', desc: 'Programming and implementation of all features' },
        { title: 'Testing', desc: 'Compatibility and performance verification' },
        { title: 'Launch', desc: 'Website publication and usage training' }
      ]
    },
    portfolio: {
      title: 'Previous projects',
      subtitle: 'Examples of one-page websites we created'
    },
    benefits: {
      title: 'Benefits',
      items: [
        { title: 'Direct Communication', desc: 'Clear and objective message on a single page' },
        { title: 'Optimized Conversion', desc: 'Structure focused on generating leads and sales' },
        { title: 'Easy Maintenance', desc: 'Simple content updates' },
        { title: 'Cost-Effective', desc: 'Professional solution with accessible investment' }
      ]
    },
    cta: {
      title: 'Ready to have your one-page website?',
      subtitle: 'Contact us and receive a personalized quote',
      button: 'Request Quote'
    }
  },

  websitesInformativos: {
    title: 'Informational Websites',
    subtitle: 'Professional websites for companies that want to present their business online',
    description: 'We develop complete and professional informational websites for companies that need a solid digital presence. Ideal for presenting services, credibility and institutional information.',
    includes: {
      title: 'What\'s included',
      items: [
        { title: 'Multiple Pages', desc: 'Complete structure with various sections and pages' },
        { title: 'Management System', desc: 'Administrative panel to manage content' },
        { title: 'Integrated Blog', desc: 'News and articles area for SEO' },
        { title: 'Image Gallery', desc: 'Visual showcase of your projects and work' },
        { title: 'Advanced Forms', desc: 'Contact, quotes and other features' },
        { title: 'SSL Certificate', desc: 'Security and trust for visitors' }
      ]
    },
    process: {
      title: 'How we work',
      steps: [
        { title: 'Analysis', desc: 'Study of your business, competition and target audience' },
        { title: 'Architecture', desc: 'Definition of page structure and navigation' },
        { title: 'Content', desc: 'Organization and optimization of texts and images' },
        { title: 'UI/UX Design', desc: 'Interface creation focused on user experience' },
        { title: 'Programming', desc: 'Development with modern and secure technologies' },
        { title: 'Delivery', desc: 'Launch, training and after-sales support' }
      ]
    },
    portfolio: {
      title: 'Previous projects',
      subtitle: 'Informational websites we developed for companies'
    },
    benefits: {
      title: 'Benefits',
      items: [
        { title: 'Credibility', desc: 'Professional presence that conveys trust' },
        { title: 'Visibility', desc: 'Better positioning in search engines' },
        { title: 'Scalability', desc: 'Structure prepared to grow with the business' },
        { title: 'Continuous Support', desc: 'Technical assistance and regular updates' }
      ]
    },
    cta: {
      title: 'Take your company digital',
      subtitle: 'Request a personalized proposal for your informational website',
      button: 'Request Proposal'
    }
  },

  ecommerce: {
    title: 'E-commerce',
    subtitle: 'Online stores optimized to sell your products efficiently',
    description: 'We create complete and secure e-commerce platforms, ready to boost your online sales. Customized solutions with integrated product management, payments and shipping.',
    includes: {
      title: 'What\'s included',
      items: [
        { title: 'Product Catalog', desc: 'Complete product and category management system' },
        { title: 'Shopping Cart', desc: 'Intuitive and secure shopping experience' },
        { title: 'Online Payments', desc: 'Integration with secure payment gateways' },
        { title: 'Stock Management', desc: 'Automatic inventory and availability control' },
        { title: 'Customer Area', desc: 'Portal for purchase history and personal data' },
        { title: 'Admin Panel', desc: 'Complete dashboard to manage the entire store' }
      ]
    },
    process: {
      title: 'How we work',
      steps: [
        { title: 'Strategy', desc: 'Definition of business model and commercial objectives' },
        { title: 'Platform', desc: 'Choice of technology suitable for your project' },
        { title: 'Design', desc: 'Interface focused on conversion and shopping experience' },
        { title: 'Integrations', desc: 'Configuration of payments, shipping and systems' },
        { title: 'Testing', desc: 'Validation of the entire purchase process' },
        { title: 'Launch', desc: 'Publication and training for store management' }
      ]
    },
    portfolio: {
      title: 'Previous projects',
      subtitle: 'Online stores we developed that are selling'
    },
    benefits: {
      title: 'Benefits',
      items: [
        { title: '24/7 Sales', desc: 'Store open every day, at any time' },
        { title: 'Global Reach', desc: 'Sell anywhere in the world' },
        { title: 'Automation', desc: 'Automated processes that save time' },
        { title: 'Data Analysis', desc: 'Detailed reports on sales and customers' }
      ]
    },
    cta: {
      title: 'Start selling online today',
      subtitle: 'Request a quote for your online store and increase your sales',
      button: 'Request Quote'
    }
  },

  // Identidade Visual Page
  'identidadeVisual.meta.title': 'Visual Identity - Professional Brand Creation | MidiaHost',
  'identidadeVisual.meta.description': 'We create complete visual identities that highlight your brand. Logo, color palette, typography and professional brand manual.',
  'identidadeVisual.meta.keywords': 'visual identity, logo creation, branding, brand design, brand manual, color palette',
  
  'identidadeVisual.hero.title': 'Visual Identity',
  'identidadeVisual.hero.subtitle': 'Create a memorable and professional brand',
  'identidadeVisual.hero.description': 'We develop complete visual identities that convey your brand values and create emotional connection with your audience. From logo to brand manual, we ensure consistency and visual impact at all touchpoints.',
  
  'identidadeVisual.includesTitle': 'What\'s Included',
  'identidadeVisual.includes.logo.title': 'Logo Design',
  'identidadeVisual.includes.logo.description': 'Creation of unique and memorable logo that represents your brand essence',
  'identidadeVisual.includes.colors.title': 'Color Palette',
  'identidadeVisual.includes.colors.description': 'Definition of primary and secondary colors with exact codes for all applications',
  'identidadeVisual.includes.typography.title': 'Typography',
  'identidadeVisual.includes.typography.description': 'Selection of fonts that complement the identity and ensure readability',
  'identidadeVisual.includes.manual.title': 'Brand Manual',
  'identidadeVisual.includes.manual.description': 'Complete guide with usage rules, variations and correct identity applications',
  'identidadeVisual.includes.patterns.title': 'Visual Patterns',
  'identidadeVisual.includes.patterns.description': 'Complementary graphic elements such as icons, textures and patterns',
  'identidadeVisual.includes.files.title': 'Final Files',
  'identidadeVisual.includes.files.description': 'All files in vector and raster formats for print and digital',
  
  'identidadeVisual.processTitle': 'How We Work',
  'identidadeVisual.process.discovery.title': 'Discovery',
  'identidadeVisual.process.discovery.description': 'Initial meeting to understand your brand, values, target audience and goals',
  'identidadeVisual.process.research.title': 'Research',
  'identidadeVisual.process.research.description': 'Market analysis, competition and industry trends',
  'identidadeVisual.process.concepts.title': 'Concepts',
  'identidadeVisual.process.concepts.description': 'Development of 3 different creative proposals to choose from',
  'identidadeVisual.process.refinement.title': 'Refinement',
  'identidadeVisual.process.refinement.description': 'Adjustments and improvements to the chosen concept until perfection',
  'identidadeVisual.process.system.title': 'Visual System',
  'identidadeVisual.process.system.description': 'Creation of all complementary elements and brand applications',
  'identidadeVisual.process.delivery.title': 'Delivery',
  'identidadeVisual.process.delivery.description': 'Delivery of brand manual and all organized final files',
  
  'identidadeVisual.portfolioTitle': 'Previous Projects',
  'identidadeVisual.portfolio.tech.title': 'Tech Startup',
  'identidadeVisual.portfolio.tech.description': 'Modern and minimalist visual identity for software company',
  'identidadeVisual.portfolio.restaurant.title': 'Premium Restaurant',
  'identidadeVisual.portfolio.restaurant.description': 'Sophisticated branding for fine dining restaurant',
  'identidadeVisual.portfolio.fitness.title': 'Fitness Center',
  'identidadeVisual.portfolio.fitness.description': 'Energetic and motivating identity for gym and wellness',
  
  'identidadeVisual.benefitsTitle': 'Benefits',
  'identidadeVisual.benefits.recognition.title': 'Immediate Recognition',
  'identidadeVisual.benefits.recognition.description': 'A strong identity makes your brand easily recognizable and memorable',
  'identidadeVisual.benefits.credibility.title': 'Professional Credibility',
  'identidadeVisual.benefits.credibility.description': 'Professional design conveys trust and seriousness to your audience',
  'identidadeVisual.benefits.consistency.title': 'Visual Consistency',
  'identidadeVisual.benefits.consistency.description': 'Brand manual ensures correct application in all materials',
  'identidadeVisual.benefits.connection.title': 'Emotional Connection',
  'identidadeVisual.benefits.connection.description': 'Well-developed identity creates emotional bond with customers',
  
  'identidadeVisual.cta.title': 'Ready to Create Your Brand?',
  'identidadeVisual.cta.description': 'Let\'s develop a visual identity that highlights your business and wins customers.',
  'identidadeVisual.cta.button': 'Request Proposal',

  // Materiais Promocionais Page
  'materiaisPromocionais.meta.title': 'Promotional Materials - Digital Marketing Design | MidiaHost',
  'materiaisPromocionais.meta.description': 'We create impactful promotional materials for social media, email marketing, digital banners and advertising campaigns.',
  'materiaisPromocionais.meta.keywords': 'promotional materials, social media design, email marketing, digital banners, visual marketing',
  
  'materiaisPromocionais.hero.title': 'Promotional Materials',
  'materiaisPromocionais.hero.subtitle': 'Stand out with impactful promotional design',
  'materiaisPromocionais.hero.description': 'We create promotional materials that capture attention and generate results. From social media posts to email marketing campaigns, we develop visual content that converts and strengthens your digital presence.',
  
  'materiaisPromocionais.includesTitle': 'What\'s Included',
  'materiaisPromocionais.includes.social.title': 'Social Media Posts',
  'materiaisPromocionais.includes.social.description': 'Design of posts, stories and covers for Instagram, Facebook, LinkedIn and other platforms',
  'materiaisPromocionais.includes.banners.title': 'Digital Banners',
  'materiaisPromocionais.includes.banners.description': 'Banners for websites, Google Ads and online advertising campaigns',
  'materiaisPromocionais.includes.email.title': 'Email Marketing',
  'materiaisPromocionais.includes.email.description': 'Professional templates for newsletters and email campaigns',
  'materiaisPromocionais.includes.presentations.title': 'Presentations',
  'materiaisPromocionais.includes.presentations.description': 'Corporate slides and impactful business presentations',
  'materiaisPromocionais.includes.promotional.title': 'Promotional Materials',
  'materiaisPromocionais.includes.promotional.description': 'Coupons, vouchers, ads and other promotional materials',
  'materiaisPromocionais.includes.infographics.title': 'Infographics',
  'materiaisPromocionais.includes.infographics.description': 'Data and information visualization in an attractive and clear way',
  
  'materiaisPromocionais.processTitle': 'How We Work',
  'materiaisPromocionais.process.briefing.title': 'Briefing',
  'materiaisPromocionais.process.briefing.description': 'Definition of objectives, target audience and campaign message',
  'materiaisPromocionais.process.strategy.title': 'Visual Strategy',
  'materiaisPromocionais.process.strategy.description': 'Planning of creative concept and visual line of materials',
  'materiaisPromocionais.process.concepts.title': 'Creation',
  'materiaisPromocionais.process.concepts.description': 'Development of designs based on defined strategy',
  'materiaisPromocionais.process.production.title': 'Production',
  'materiaisPromocionais.process.production.description': 'Finalization of all materials in necessary formats',
  'materiaisPromocionais.process.review.title': 'Review',
  'materiaisPromocionais.process.review.description': 'Final adjustments based on your feedback',
  'materiaisPromocionais.process.delivery.title': 'Delivery',
  'materiaisPromocionais.process.delivery.description': 'Delivery of files optimized for each platform',
  
  'materiaisPromocionais.portfolioTitle': 'Previous Projects',
  'materiaisPromocionais.portfolio.social.title': 'Social Media Campaign',
  'materiaisPromocionais.portfolio.social.description': 'Series of posts and stories for product launch',
  'materiaisPromocionais.portfolio.email.title': 'Email Marketing',
  'materiaisPromocionais.portfolio.email.description': 'Newsletter templates for monthly campaign',
  'materiaisPromocionais.portfolio.banners.title': 'Advertising Banners',
  'materiaisPromocionais.portfolio.banners.description': 'Set of banners for Google Ads campaign',
  
  'materiaisPromocionais.benefitsTitle': 'Benefits',
  'materiaisPromocionais.benefits.visibility.title': 'Greater Visibility',
  'materiaisPromocionais.benefits.visibility.description': 'Well-designed materials stand out and capture more attention',
  'materiaisPromocionais.benefits.engagement.title': 'More Engagement',
  'materiaisPromocionais.benefits.engagement.description': 'Attractive design generates more interactions and shares',
  'materiaisPromocionais.benefits.conversion.title': 'Better Conversion',
  'materiaisPromocionais.benefits.conversion.description': 'Professional materials increase conversion rate',
  'materiaisPromocionais.benefits.branding.title': 'Brand Reinforcement',
  'materiaisPromocionais.benefits.branding.description': 'Visual consistency strengthens brand identity',
  
  'materiaisPromocionais.cta.title': 'Ready to Boost Your Marketing?',
  'materiaisPromocionais.cta.description': 'Let\'s create promotional materials that highlight your brand and generate results.',
  'materiaisPromocionais.cta.button': 'Request Quote',

  // Design para Impressão Page
  'designImpressao.meta.title': 'Print Design - Professional Graphic Materials | MidiaHost',
  'designImpressao.meta.description': 'We create high-quality print design: flyers, posters, banners, catalogs, business cards and packaging.',
  'designImpressao.meta.keywords': 'print design, flyers, posters, banners, catalogs, business cards, packaging',
  
  'designImpressao.hero.title': 'Print Design',
  'designImpressao.hero.subtitle': 'High-quality printed materials',
  'designImpressao.hero.description': 'We develop print design with attention to technical details and graphic quality. From flyers to packaging, we create materials that impress and effectively communicate your message in the physical world.',
  
  'designImpressao.includesTitle': 'What\'s Included',
  'designImpressao.includes.flyers.title': 'Flyers and Leaflets',
  'designImpressao.includes.flyers.description': 'Design of promotional flyers and informational leaflets with professional finish',
  'designImpressao.includes.posters.title': 'Posters',
  'designImpressao.includes.posters.description': 'Impactful posters for events, promotions and advertising campaigns',
  'designImpressao.includes.banners.title': 'Banners and Roll-ups',
  'designImpressao.includes.banners.description': 'Physical banners and roll-ups for events, fairs and points of sale',
  'designImpressao.includes.catalogs.title': 'Catalogs and Brochures',
  'designImpressao.includes.catalogs.description': 'Product catalogs and corporate brochures with professional layout',
  'designImpressao.includes.cards.title': 'Business Cards',
  'designImpressao.includes.cards.description': 'Elegant business cards that make a good first impression',
  'designImpressao.includes.packaging.title': 'Packaging',
  'designImpressao.includes.packaging.description': 'Packaging design that protects and values your products',
  
  'designImpressao.processTitle': 'How We Work',
  'designImpressao.process.briefing.title': 'Briefing',
  'designImpressao.process.briefing.description': 'Definition of objectives, technical specifications and printing requirements',
  'designImpressao.process.concept.title': 'Concept',
  'designImpressao.process.concept.description': 'Development of creative concept suitable for the material',
  'designImpressao.process.design.title': 'Design',
  'designImpressao.process.design.description': 'Layout creation with attention to CMYK colors and resolution',
  'designImpressao.process.prepress.title': 'Pre-press',
  'designImpressao.process.prepress.description': 'Technical preparation of files with bleeds and crop marks',
  'designImpressao.process.approval.title': 'Approval',
  'designImpressao.process.approval.description': 'Final review and approval before sending to print',
  'designImpressao.process.production.title': 'Production',
  'designImpressao.process.production.description': 'Print monitoring and quality control',
  
  'designImpressao.portfolioTitle': 'Previous Projects',
  'designImpressao.portfolio.brochure.title': 'Corporate Brochure',
  'designImpressao.portfolio.brochure.description': '24-page institutional catalog for service company',
  'designImpressao.portfolio.poster.title': 'Event Poster',
  'designImpressao.portfolio.poster.description': 'Promotional poster for music festival',
  'designImpressao.portfolio.packaging.title': 'Premium Packaging',
  'designImpressao.portfolio.packaging.description': 'Packaging design for gourmet product line',
  
  'designImpressao.benefitsTitle': 'Benefits',
  'designImpressao.benefits.quality.title': 'Guaranteed Quality',
  'designImpressao.benefits.quality.description': 'Files technically prepared for perfect printing',
  'designImpressao.benefits.tangible.title': 'Tangible Impact',
  'designImpressao.benefits.tangible.description': 'Physical materials create stronger connection with audience',
  'designImpressao.benefits.professional.title': 'Professional Image',
  'designImpressao.benefits.professional.description': 'Quality printed materials convey professionalism',
  'designImpressao.benefits.durability.title': 'Durability',
  'designImpressao.benefits.durability.description': 'Printed materials have long lifespan and constant presence',
  
  'designImpressao.cta.title': 'Ready to Impress?',
  'designImpressao.cta.description': 'Let\'s create printed materials that highlight your brand in the physical world.',
  'designImpressao.cta.button': 'Request Quote',

  // Fotografia Service
  'services.fotografia.meta.title': 'Professional Photography | MidiaHost',
  'services.fotografia.meta.description': 'Professional photography services for events, brands, and projects. We capture authentic moments with superior technical quality and fast delivery.',
  'services.fotografia.meta.keywords': 'professional photography, event photography, corporate photography, product photography, brand photography',
  'services.fotografia.hero.title': 'Professional Photography',
  'services.fotografia.hero.subtitle': 'We capture the essence of your brand',
  'services.fotografia.hero.description': 'Professional photography services for corporate events, products, portraits, and branding. We transform moments into memorable images with superior technical quality and creative vision.',
  'services.fotografia.includes.title': 'What\'s Included',
  'services.fotografia.includes.item1.title': 'Full Coverage',
  'services.fotografia.includes.item1.description': 'Complete photographic coverage of the event or session with multiple angles and perspectives.',
  'services.fotografia.includes.item2.title': 'Corporate Photography',
  'services.fotografia.includes.item2.description': 'Professional portraits, headshots, and team photography for corporate use.',
  'services.fotografia.includes.item3.title': 'Product Photography',
  'services.fotografia.includes.item3.description': 'High-quality product images for e-commerce, catalogs, and marketing.',
  'services.fotografia.includes.item4.title': 'Professional Editing',
  'services.fotografia.includes.item4.description': 'Professional treatment and editing of all selected photographs.',
  'services.fotografia.includes.item5.title': 'Online Gallery',
  'services.fotografia.includes.item5.description': 'Access to private online gallery for viewing and downloading images.',
  'services.fotografia.includes.item6.title': 'Fast Delivery',
  'services.fotografia.includes.item6.description': 'Delivery of edited photographs in high resolution within 7 business days.',
  'services.fotografia.process.title': 'How We Work',
  'services.fotografia.process.step1.title': 'Initial Briefing',
  'services.fotografia.process.step1.description': 'Meeting to understand objectives, desired style, and specific project requirements.',
  'services.fotografia.process.step2.title': 'Planning',
  'services.fotografia.process.step2.description': 'Definition of locations, schedules, necessary equipment, and detailed shot list.',
  'services.fotografia.process.step3.title': 'Technical Preparation',
  'services.fotografia.process.step3.description': 'Equipment setup, lighting configuration, and preparation of all technical details.',
  'services.fotografia.process.step4.title': 'Photo Session',
  'services.fotografia.process.step4.description': 'Execution of session with professional direction and capture of all planned images.',
  'services.fotografia.process.step5.title': 'Selection and Editing',
  'services.fotografia.process.step5.description': 'Curation of best images and professional editing with color correction and retouching.',
  'services.fotografia.process.step6.title': 'Final Delivery',
  'services.fotografia.process.step6.description': 'Delivery of photographs in high resolution through private online gallery.',
  'services.fotografia.portfolio.title': 'Previous Work',
  'services.fotografia.portfolio.project1.title': 'Tech Summit Corporate Event',
  'services.fotografia.portfolio.project1.description': 'Complete coverage of technology conference with 500+ participants.',
  'services.fotografia.portfolio.project2.title': 'Premium Product Catalog',
  'services.fotografia.portfolio.project2.description': 'Product photography for luxury brand with 50+ items photographed.',
  'services.fotografia.portfolio.project3.title': 'Executive Team Corporate Portraits',
  'services.fotografia.portfolio.project3.description': 'Professional portrait session for executive team of multinational company.',
  'services.fotografia.benefits.title': 'Why Choose Us',
  'services.fotografia.benefits.benefit1.title': 'Professional Equipment',
  'services.fotografia.benefits.benefit1.description': 'Full-frame cameras, premium lenses, and professional lighting for maximum quality.',
  'services.fotografia.benefits.benefit2.title': 'Experienced Photographers',
  'services.fotografia.benefits.benefit2.description': 'Team with years of experience in commercial photography and corporate events.',
  'services.fotografia.benefits.benefit3.title': 'Professional Lighting',
  'services.fotografia.benefits.benefit3.description': 'Appropriate lighting setup for each situation, ensuring consistent results.',
  'services.fotografia.benefits.benefit4.title': 'Fast Digital Delivery',
  'services.fotografia.benefits.benefit4.description': 'Online gallery with high-resolution download and web-optimized formats.',
  'services.fotografia.cta.title': 'Ready to Capture Memorable Moments?',
  'services.fotografia.cta.description': 'Contact us to discuss your photography project and receive a personalized proposal.',
  'services.fotografia.cta.button': 'Request Quote',

  // Videografia Service
  'services.videografia.meta.title': 'Professional Videography | MidiaHost',
  'services.videografia.meta.description': 'Professional video production for brands, events, and storytelling. We create high-quality audiovisual content that communicates and moves.',
  'services.videografia.meta.keywords': 'professional videography, video production, corporate video, promotional video, visual storytelling',
  'services.videografia.hero.title': 'Professional Videography',
  'services.videografia.hero.subtitle': 'We tell stories through moving images',
  'services.videografia.hero.description': 'Professional video production for promotional, institutional, and brand storytelling content. We create impactful visual narratives that connect with your audience.',
  'services.videografia.includes.title': 'What\'s Included',
  'services.videografia.includes.item1.title': 'Full Production',
  'services.videografia.includes.item1.description': 'Pre-production, filming, and post-production with complete technical team.',
  'services.videografia.includes.item2.title': 'Multi-Camera Filming',
  'services.videografia.includes.item2.description': 'Capture with multiple cameras for complete coverage and dynamic angles.',
  'services.videografia.includes.item3.title': 'Professional Audio',
  'services.videografia.includes.item3.description': 'Audio recording with professional equipment and quality microphones.',
  'services.videografia.includes.item4.title': 'Advanced Editing',
  'services.videografia.includes.item4.description': 'Professional editing with color correction, motion graphics, and visual effects.',
  'services.videografia.includes.item5.title': 'Subtitles and Graphics',
  'services.videografia.includes.item5.description': 'Creation of subtitles, lower thirds, and custom graphic elements.',
  'services.videografia.includes.item6.title': 'Multiple Formats',
  'services.videografia.includes.item6.description': 'Delivery in different formats optimized for web, social media, and TV.',
  'services.videografia.process.title': 'How We Work',
  'services.videografia.process.step1.title': 'Concept and Briefing',
  'services.videografia.process.step1.description': 'Definition of objectives, message, target audience, and creative concept of the video.',
  'services.videografia.process.step2.title': 'Pre-Production',
  'services.videografia.process.step2.description': 'Script development, storyboard, location planning, and casting.',
  'services.videografia.process.step3.title': 'Technical Preparation',
  'services.videografia.process.step3.description': 'Equipment selection, technical tests, and preparation of all logistics.',
  'services.videografia.process.step4.title': 'Filming',
  'services.videografia.process.step4.description': 'Production execution with professional direction and capture of all scenes.',
  'services.videografia.process.step5.title': 'Post-Production',
  'services.videografia.process.step5.description': 'Editing, color correction, sound design, motion graphics, and finalization.',
  'services.videografia.process.step6.title': 'Delivery and Revisions',
  'services.videografia.process.step6.description': 'Presentation of final video with up to 2 rounds of revisions included.',
  'services.videografia.portfolio.title': 'Previous Work',
  'services.videografia.portfolio.project1.title': 'Tech Company Corporate Video',
  'services.videografia.portfolio.project1.description': '3-minute institutional video presenting company culture and values.',
  'services.videografia.portfolio.project2.title': 'Brand Storytelling Campaign',
  'services.videografia.portfolio.project2.description': 'Series of 5 emotional videos telling real customer stories.',
  'services.videografia.portfolio.project3.title': 'Product Promotional Video',
  'services.videografia.portfolio.project3.description': 'Product launch video with demonstration and testimonials.',
  'services.videografia.benefits.title': 'Why Choose Us',
  'services.videografia.benefits.benefit1.title': 'Cinematic Quality',
  'services.videografia.benefits.benefit1.description': '4K filming with cinema cameras and professional lenses for superior quality.',
  'services.videografia.benefits.benefit2.title': 'Creative Narrative',
  'services.videografia.benefits.benefit2.description': 'Engaging storytelling that communicates the message emotionally and effectively.',
  'services.videografia.benefits.benefit3.title': 'Efficient Production',
  'services.videografia.benefits.benefit3.description': 'Optimized processes that ensure on-time delivery without compromising quality.',
  'services.videografia.benefits.benefit4.title': 'Format Versatility',
  'services.videografia.benefits.benefit4.description': 'Content adaptation for different platforms and distribution needs.',
  'services.videografia.cta.title': 'Ready to Create Impactful Visual Content?',
  'services.videografia.cta.description': 'Contact us to discuss your video project and receive a personalized proposal.',
  'services.videografia.cta.button': 'Request Quote',

  // Streaming ao Vivo Service
  'services.streaming.meta.title': 'Professional Live Streaming | MidiaHost',
  'services.streaming.meta.description': 'Live streaming services for events, conferences, and online broadcasts. Professional technology to reach global audiences in real-time.',
  'services.streaming.meta.keywords': 'live streaming, online broadcast, live streaming, virtual events, professional webcast',
  'services.streaming.hero.title': 'Live Streaming',
  'services.streaming.hero.subtitle': 'Connect with global audiences in real-time',
  'services.streaming.hero.description': 'Professional live streaming services for events, conferences, and online broadcasts. Cutting-edge technology and experienced team to ensure stable, high-quality transmissions.',
  'services.streaming.includes.title': 'What\'s Included',
  'services.streaming.includes.item1.title': 'Multi-Platform Broadcasting',
  'services.streaming.includes.item1.description': 'Simultaneous streaming to YouTube, Facebook, LinkedIn, and custom platforms.',
  'services.streaming.includes.item2.title': 'Multiple Cameras',
  'services.streaming.includes.item2.description': 'Setup with 2-4 cameras for dynamic coverage and real-time switching.',
  'services.streaming.includes.item3.title': 'Professional Audio',
  'services.streaming.includes.item3.description': 'Audio system with wireless microphones and professional mixing.',
  'services.streaming.includes.item4.title': 'Live Graphics',
  'services.streaming.includes.item4.description': 'Lower thirds, presentation slides, and graphic overlays in real-time.',
  'services.streaming.includes.item5.title': 'Chat Moderation',
  'services.streaming.includes.item5.description': 'Comment management and audience interaction during broadcast.',
  'services.streaming.includes.item6.title': 'Recording and Archive',
  'services.streaming.includes.item6.description': 'High-quality recording for archive and later availability.',
  'services.streaming.process.title': 'How We Work',
  'services.streaming.process.step1.title': 'Technical Planning',
  'services.streaming.process.step1.description': 'Requirements analysis, platform definition, and technical setup planning.',
  'services.streaming.process.step2.title': 'Site Visit',
  'services.streaming.process.step2.description': 'Space evaluation, internet testing, and equipment positioning planning.',
  'services.streaming.process.step3.title': 'Setup and Testing',
  'services.streaming.process.step3.description': 'Equipment installation, streaming configuration, and complete technical tests.',
  'services.streaming.process.step4.title': 'Technical Rehearsal',
  'services.streaming.process.step4.description': 'Rehearsal with speakers to test audio, video, and broadcast flow.',
  'services.streaming.process.step5.title': 'Live Broadcast',
  'services.streaming.process.step5.description': 'Broadcast execution with constant monitoring and technical management.',
  'services.streaming.process.step6.title': 'Post-Event',
  'services.streaming.process.step6.description': 'Delivery of edited recording and audience metrics report.',
  'services.streaming.portfolio.title': 'Previous Work',
  'services.streaming.portfolio.project1.title': 'Tech Summit 2024 Conference',
  'services.streaming.portfolio.project1.description': '2-day conference streaming with 5000+ simultaneous online viewers.',
  'services.streaming.portfolio.project2.title': 'Monthly Corporate Webinar',
  'services.streaming.portfolio.project2.description': 'Series of monthly webinars with presentations and interactive Q&A.',
  'services.streaming.portfolio.project3.title': 'Hybrid Launch Event',
  'services.streaming.portfolio.project3.description': 'Product launch event with in-person audience and 2000+ online.',
  'services.streaming.benefits.title': 'Why Choose Us',
  'services.streaming.benefits.benefit1.title': 'Global Reach',
  'services.streaming.benefits.benefit1.description': 'Broadcast to audiences anywhere in the world without geographical limitations.',
  'services.streaming.benefits.benefit2.title': 'Guaranteed Stability',
  'services.streaming.benefits.benefit2.description': 'Internet redundancy and backup equipment to ensure fail-safe transmission.',
  'services.streaming.benefits.benefit3.title': 'Dedicated Technical Support',
  'services.streaming.benefits.benefit3.description': 'Technical team present throughout the event to resolve any situation.',
  'services.streaming.benefits.benefit4.title': 'Metrics and Analytics',
  'services.streaming.benefits.benefit4.description': 'Detailed reports on audience, engagement, and broadcast performance.',
  'services.streaming.cta.title': 'Ready to Broadcast Your Event?',
  'services.streaming.cta.description': 'Contact us to discuss your event and receive a personalized streaming proposal.',
  'services.streaming.cta.button': 'Request Quote',

  // Footer
  "footer.slogan": "Where creativity meets performance",
  "footer.desc": "Creative digital solutions to transform your company\'s online presence",
  "footer.newsletter.title": "Newsletter",
  "footer.newsletter.desc": "Subscribe to receive the latest news",
  "footer.newsletter.placeholder": "Your email",
  "footer.newsletter.privacy": "We respect your",
  "footer.newsletter.privacyLink": "privacy",
  "footer.services.title": "Services",
  "footer.services.websites": "Website Creation",
  "footer.services.design": "Graphic Design",
  "footer.services.ecommerce": "E-commerce",
  "footer.services.events": "Event Coverage",
  "footer.services.cloud": "Cloud Infrastructure",
  "footer.social.title": "Follow us",
  "footer.copyright": "All rights reserved.",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",

  // Identidade Visual Page
  'identidadeVisual.meta.title': 'Visual Identity - Professional Brand Creation | MidiaHost',
  'identidadeVisual.meta.description': 'We create complete visual identities that highlight your brand. Logo, color palette, typography and professional brand manual.',
  'identidadeVisual.meta.keywords': 'visual identity, logo creation, branding, brand design, brand manual, color palette',
  
  'identidadeVisual.hero.title': 'Visual Identity',
  'identidadeVisual.hero.subtitle': 'Create a memorable and professional brand',
  'identidadeVisual.hero.description': 'We develop complete visual identities that convey your brand values and create emotional connection with your audience. From logo to brand manual, we ensure consistency and visual impact at all touchpoints.',
  
  'identidadeVisual.includesTitle': 'What\'s Included',
  'identidadeVisual.includes.logo.title': 'Logo Design',
  'identidadeVisual.includes.logo.description': 'Creation of unique and memorable logo that represents your brand essence',
  'identidadeVisual.includes.colors.title': 'Color Palette',
  'identidadeVisual.includes.colors.description': 'Definition of primary and secondary colors with exact codes for all applications',
  'identidadeVisual.includes.typography.title': 'Typography',
  'identidadeVisual.includes.typography.description': 'Selection of fonts that complement the identity and ensure readability',
  'identidadeVisual.includes.manual.title': 'Brand Manual',
  'identidadeVisual.includes.manual.description': 'Complete guide with usage rules, variations and correct identity applications',
  'identidadeVisual.includes.patterns.title': 'Visual Patterns',
  'identidadeVisual.includes.patterns.description': 'Complementary graphic elements such as icons, textures and patterns',
  'identidadeVisual.includes.files.title': 'Final Files',
  'identidadeVisual.includes.files.description': 'All files in vector and raster formats for print and digital',
  
  'identidadeVisual.processTitle': 'How We Work',
  'identidadeVisual.process.discovery.title': 'Discovery',
  'identidadeVisual.process.discovery.description': 'Initial meeting to understand your brand, values, target audience and goals',
  'identidadeVisual.process.research.title': 'Research',
  'identidadeVisual.process.research.description': 'Market analysis, competition and industry trends',
  'identidadeVisual.process.concepts.title': 'Concepts',
  'identidadeVisual.process.concepts.description': 'Development of 3 different creative proposals to choose from',
  'identidadeVisual.process.refinement.title': 'Refinement',
  'identidadeVisual.process.refinement.description': 'Adjustments and improvements to the chosen concept until perfection',
  'identidadeVisual.process.system.title': 'Visual System',
  'identidadeVisual.process.system.description': 'Creation of all complementary elements and brand applications',
  'identidadeVisual.process.delivery.title': 'Delivery',
  'identidadeVisual.process.delivery.description': 'Delivery of brand manual and all organized final files',
  
  'identidadeVisual.portfolioTitle': 'Previous Projects',
  'identidadeVisual.portfolio.tech.title': 'Tech Startup',
  'identidadeVisual.portfolio.tech.description': 'Modern and minimalist visual identity for software company',
  'identidadeVisual.portfolio.restaurant.title': 'Premium Restaurant',
  'identidadeVisual.portfolio.restaurant.description': 'Sophisticated branding for fine dining restaurant',
  'identidadeVisual.portfolio.fitness.title': 'Fitness Center',
  'identidadeVisual.portfolio.fitness.description': 'Energetic and motivating identity for gym and wellness',
  
  'identidadeVisual.benefitsTitle': 'Benefits',
  'identidadeVisual.benefits.recognition.title': 'Immediate Recognition',
  'identidadeVisual.benefits.recognition.description': 'A strong identity makes your brand easily recognizable and memorable',
  'identidadeVisual.benefits.credibility.title': 'Professional Credibility',
  'identidadeVisual.benefits.credibility.description': 'Professional design conveys trust and seriousness to your audience',
  'identidadeVisual.benefits.consistency.title': 'Visual Consistency',
  'identidadeVisual.benefits.consistency.description': 'Brand manual ensures correct application in all materials',
  'identidadeVisual.benefits.connection.title': 'Emotional Connection',
  'identidadeVisual.benefits.connection.description': 'Well-developed identity creates emotional bond with customers',
  
  'identidadeVisual.cta.title': 'Ready to Create Your Brand?',
  'identidadeVisual.cta.description': 'Let\'s develop a visual identity that highlights your business and wins customers.',
  'identidadeVisual.cta.button': 'Request Proposal',

  // Materiais Promocionais Page
  'materiaisPromocionais.meta.title': 'Promotional Materials - Digital Marketing Design | MidiaHost',
  'materiaisPromocionais.meta.description': 'We create impactful promotional materials for social media, email marketing, digital banners and advertising campaigns.',
  'materiaisPromocionais.meta.keywords': 'promotional materials, social media design, email marketing, digital banners, visual marketing',
  
  'materiaisPromocionais.hero.title': 'Promotional Materials',
  'materiaisPromocionais.hero.subtitle': 'Stand out with impactful promotional design',
  'materiaisPromocionais.hero.description': 'We create promotional materials that capture attention and generate results. From social media posts to email marketing campaigns, we develop visual content that converts and strengthens your digital presence.',
  
  'materiaisPromocionais.includesTitle': 'What\'s Included',
  'materiaisPromocionais.includes.social.title': 'Social Media Posts',
  'materiaisPromocionais.includes.social.description': 'Design of posts, stories and covers for Instagram, Facebook, LinkedIn and other platforms',
  'materiaisPromocionais.includes.banners.title': 'Digital Banners',
  'materiaisPromocionais.includes.banners.description': 'Banners for websites, Google Ads and online advertising campaigns',
  'materiaisPromocionais.includes.email.title': 'Email Marketing',
  'materiaisPromocionais.includes.email.description': 'Professional templates for newsletters and email campaigns',
  'materiaisPromocionais.includes.presentations.title': 'Presentations',
  'materiaisPromocionais.includes.presentations.description': 'Corporate slides and impactful business presentations',
  'materiaisPromocionais.includes.promotional.title': 'Promotional Materials',
  'materiaisPromocionais.includes.promotional.description': 'Coupons, vouchers, ads and other promotional materials',
  'materiaisPromocionais.includes.infographics.title': 'Infographics',
  'materiaisPromocionais.includes.infographics.description': 'Data and information visualization in an attractive and clear way',
  
  'materiaisPromocionais.processTitle': 'How We Work',
  'materiaisPromocionais.process.briefing.title': 'Briefing',
  'materiaisPromocionais.process.briefing.description': 'Definition of objectives, target audience and campaign message',
  'materiaisPromocionais.process.strategy.title': 'Visual Strategy',
  'materiaisPromocionais.process.strategy.description': 'Planning of creative concept and visual line of materials',
  'materiaisPromocionais.process.concepts.title': 'Creation',
  'materiaisPromocionais.process.concepts.description': 'Development of designs based on defined strategy',
  'materiaisPromocionais.process.production.title': 'Production',
  'materiaisPromocionais.process.production.description': 'Finalization of all materials in necessary formats',
  'materiaisPromocionais.process.review.title': 'Review',
  'materiaisPromocionais.process.review.description': 'Final adjustments based on your feedback',
  'materiaisPromocionais.process.delivery.title': 'Delivery',
  'materiaisPromocionais.process.delivery.description': 'Delivery of files optimized for each platform',
  
  'materiaisPromocionais.portfolioTitle': 'Previous Projects',
  'materiaisPromocionais.portfolio.social.title': 'Social Media Campaign',
  'materiaisPromocionais.portfolio.social.description': 'Series of posts and stories for product launch',
  'materiaisPromocionais.portfolio.email.title': 'Email Marketing',
  'materiaisPromocionais.portfolio.email.description': 'Newsletter templates for monthly campaign',
  'materiaisPromocionais.portfolio.banners.title': 'Advertising Banners',
  'materiaisPromocionais.portfolio.banners.description': 'Set of banners for Google Ads campaign',
  
  'materiaisPromocionais.benefitsTitle': 'Benefits',
  'materiaisPromocionais.benefits.visibility.title': 'Greater Visibility',
  'materiaisPromocionais.benefits.visibility.description': 'Well-designed materials stand out and capture more attention',
  'materiaisPromocionais.benefits.engagement.title': 'More Engagement',
  'materiaisPromocionais.benefits.engagement.description': 'Attractive design generates more interactions and shares',
  'materiaisPromocionais.benefits.conversion.title': 'Better Conversion',
  'materiaisPromocionais.benefits.conversion.description': 'Professional materials increase conversion rate',
  'materiaisPromocionais.benefits.branding.title': 'Brand Reinforcement',
  'materiaisPromocionais.benefits.branding.description': 'Visual consistency strengthens brand identity',
  
  'materiaisPromocionais.cta.title': 'Ready to Boost Your Marketing?',
  'materiaisPromocionais.cta.description': 'Let\'s create promotional materials that highlight your brand and generate results.',
  'materiaisPromocionais.cta.button': 'Request Quote',

  // Design para Impressão Page
  'designImpressao.meta.title': 'Print Design - Professional Graphic Materials | MidiaHost',
  'designImpressao.meta.description': 'We create high-quality print design: flyers, posters, banners, catalogs, business cards and packaging.',
  'designImpressao.meta.keywords': 'print design, flyers, posters, banners, catalogs, business cards, packaging',
  
  'designImpressao.hero.title': 'Print Design',
  'designImpressao.hero.subtitle': 'High-quality printed materials',
  'designImpressao.hero.description': 'We develop print design with attention to technical details and graphic quality. From flyers to packaging, we create materials that impress and effectively communicate your message in the physical world.',
  
  'designImpressao.includesTitle': 'What\'s Included',
  'designImpressao.includes.flyers.title': 'Flyers and Leaflets',
  'designImpressao.includes.flyers.description': 'Design of promotional flyers and informational leaflets with professional finish',
  'designImpressao.includes.posters.title': 'Posters',
  'designImpressao.includes.posters.description': 'Impactful posters for events, promotions and advertising campaigns',
  'designImpressao.includes.banners.title': 'Banners and Roll-ups',
  'designImpressao.includes.banners.description': 'Physical banners and roll-ups for events, fairs and points of sale',
  'designImpressao.includes.catalogs.title': 'Catalogs and Brochures',
  'designImpressao.includes.catalogs.description': 'Product catalogs and corporate brochures with professional layout',
  'designImpressao.includes.cards.title': 'Business Cards',
  'designImpressao.includes.cards.description': 'Elegant business cards that make a good first impression',
  'designImpressao.includes.packaging.title': 'Packaging',
  'designImpressao.includes.packaging.description': 'Packaging design that protects and values your products',
  
  'designImpressao.processTitle': 'How We Work',
  'designImpressao.process.briefing.title': 'Briefing',
  'designImpressao.process.briefing.description': 'Definition of objectives, technical specifications and printing requirements',
  'designImpressao.process.concept.title': 'Concept',
  'designImpressao.process.concept.description': 'Development of creative concept suitable for the material',
  'designImpressao.process.design.title': 'Design',
  'designImpressao.process.design.description': 'Layout creation with attention to CMYK colors and resolution',
  'designImpressao.process.prepress.title': 'Pre-press',
  'designImpressao.process.prepress.description': 'Technical preparation of files with bleeds and crop marks',
  'designImpressao.process.approval.title': 'Approval',
  'designImpressao.process.approval.description': 'Final review and approval before sending to print',
  'designImpressao.process.production.title': 'Production',
  'designImpressao.process.production.description': 'Print monitoring and quality control',
  
  'designImpressao.portfolioTitle': 'Previous Projects',
  'designImpressao.portfolio.brochure.title': 'Corporate Brochure',
  'designImpressao.portfolio.brochure.description': '24-page institutional catalog for service company',
  'designImpressao.portfolio.poster.title': 'Event Poster',
  'designImpressao.portfolio.poster.description': 'Promotional poster for music festival',
  'designImpressao.portfolio.packaging.title': 'Premium Packaging',
  'designImpressao.portfolio.packaging.description': 'Packaging design for gourmet product line',
  
  'designImpressao.benefitsTitle': 'Benefits',
  'designImpressao.benefits.quality.title': 'Guaranteed Quality',
  'designImpressao.benefits.quality.description': 'Files technically prepared for perfect printing',
  'designImpressao.benefits.tangible.title': 'Tangible Impact',
  'designImpressao.benefits.tangible.description': 'Physical materials create stronger connection with audience',
  'designImpressao.benefits.professional.title': 'Professional Image',
  'designImpressao.benefits.professional.description': 'Quality printed materials convey professionalism',
  'designImpressao.benefits.durability.title': 'Durability',
  'designImpressao.benefits.durability.description': 'Printed materials have long lifespan and constant presence',
  
  'designImpressao.cta.title': 'Ready to Impress?',
  'designImpressao.cta.description': 'Let\'s create printed materials that highlight your brand in the physical world.',
  'designImpressao.cta.button': 'Request Quote',
};

export default translations;
